module.exports = __webpack_public_path__ + "media/images/Infinity-1s-200px-108da39af75ea33e44b0ac94348f180d.svg";